<div class="container">
    <div class="row">
        <div class="col">
            <div class="jumbotron w-100">
                <h1 class="text-capitalize">{{ current_type }}</h1>
            </div>
        </div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light bg-light mb-2">
        <a class="navbar-brand">Visualizza</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar_comunicazioni" aria-controls="navbar_comunicazioni" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse flex-row justify-content-between" id="navbar_comunicazioni">
            <ul class="nav nav-tabs">
                <li class="nav nav-tabs">
                    <a class="nav-link btn" [ngClass]="{'active': queryparams()['comunicazioni-type'] == 'comunicazioni'}" [routerLink]="'/comunicazioni'" [queryParams]="changeQueryParam({'comunicazioni-type': 'comunicazioni'})">Comunicazioni</a>
                </li>
                <li class="nav nav-tabs">
                    <a class="nav-link btn" [ngClass]="{'active': queryparams()['comunicazioni-type'] == 'storico'}" [routerLink]="'/comunicazioni'" [queryParams]="changeQueryParam({'comunicazioni-type': 'storico'})">Storico</a>
                </li>
            </ul>
        </div>
    </nav>

    <div [hidden]="current_type != 'comunicazioni'">
        <div class="form-group mb-5">
            <div class="col-sm-12">
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="check_email" name="check_email" [(ngModel)]="filter.email" (change)="onChangeType($event, 'email')">
                    <label class="form-check-label" for="check_email">Invia tramite email</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="check_push" name="check_push" [(ngModel)]="filter.push" (change)="onChangeType($event, 'push')">
                    <label class="form-check-label" for="check_push">Invia tramite notifica push</label>
                </div>
                <div class="form-check">
                    <input class="form-check-input" type="checkbox" id="check_app" name="check_app" [(ngModel)]="filter.app" (change)="onChangeType($event, 'app')">
                    <label class="form-check-label" for="check_app">Invia sull'app</label>
                </div>
            </div>
            <div class="col sm 12">
                <hr>
            </div>
            <div class="col-sm-12" id="user_type_wrapper">
                <h5>Tipologia o gruppo di appartenenza</h5>
                <div class="form-check" *ngFor="let user_type of getUsersType(); index as i">
                    <input class="form-check-input" checked type="checkbox" id="check_{{user_type}}" name="check_{{user_type}}" (change)="updateView()">
                    <label class="form-check-label text-capitalize" for="check_{{user_type}}">{{ user_type }}</label>
                </div>
                <div class="form-check" *ngFor="let group of getGroups(); index as i">
                    <input class="form-check-input" checked type="checkbox" id="check_{{group.id}}" name="check_{{group.id}}" (change)="updateView()">
                    <label class="form-check-label text-capitalize" for="check_{{group.id}}">{{ group.name }}</label>
                </div>
            </div>
        </div>

        <div class="form-group mb-2">
            <div class="input-group">
                <input type="text" class="form-control" id="title" placeholder="Titolo" [(ngModel)]="newsletter.title">
            </div>
        </div>

        <div class="form-group mb-2">
            <div class="input-group">
                <textarea rows="5" class="form-control" placeholder="Corpo del messaggio" [(ngModel)]="newsletter.messaggio"></textarea>
            </div>
        </div>

        <div class="form-group mb-4">
            <div class="input-group mb-2">
                <label for="documents" class="btn btn-primary">Aggiungi documento +</label>
                <input type="file" multiple class="form-control" hidden name="documents" id="documents" placeholder="Documenti" (change)="getDocuments($event)">
            </div>
            <div class="row">
                <div class="card col-lg-4 col-md-6 col-sm-12 mb-3 p-3" *ngFor="let document of newsletter.allegati; let i = index;">
                    <h6 class="mb-3"><i class="fas fa-file-upload mr-3 ml-1"></i>{{ document.filename }}<span class="float-right" (click)="newsletter.allegati.splice(i, 1)"><i class="fas fa-times ml-3 mr-1 cursor-pointer"></i></span></h6>
                    
                    <div class="row">
                        <div class="col-9 mb-2">
                            <input type="text" class="form-control" name="tag" id="tag" placeholder="Nome del Tag" [(ngModel)]="tags[document.name]">
                        </div>
                        <div class="col-3">
                            <button class="btn btn-primary btn-block" (click)="addTag(document)"><i class="fa fa-plus"></i></button>
                        </div>
                    </div>
                    <ul class="list-group" [hidden]="!document.tags?.length">
                        <li class="list-group-item" *ngFor="let tag of document.tags; let i = index;"><i class="fas fa-tag mr-3 ml-1"></i>{{ tag }}<span class="float-right" (click)="document.tags.splice(i, 1)"><i class="fas fa-trash ml-3 mr-1 cursor-pointer"></i></span></li>
                    </ul>
                    
                </div>
            </div>
        </div>

        <div class="form-group row mb-5">
            <div class="col-md-4 col-sm-6 mt-2" (click)="checkAll()"><button class="btn btn-block btn-primary">Seleziona tutti</button></div>
            <div class="col-md-4 col-sm-6 mt-2" (click)="uncheckAll()"><button class="btn btn-block btn-danger">Deseleziona tutti</button></div>
            <div class="col-md-4 col-sm-6 mt-2" (click)="send()"><button class="btn btn-block btn-success">Invia</button></div>
        </div>

        <div class="row mt-2">
            <div class="col">
                <div [hidden]="!get().length" class="table-responsive-md">
                    <table class="table">
                        <thead class="thead-primary">
                            <tr>
                                <th scope="col"></th>
                                <th scope="col">Nome</th>
                                <th scope="col">Email</th>
                                <th scope="col">Tipologia</th>
                            </tr>
                        </thead>
                        <tbody id="check_user_wrapper">
                            <tr *ngFor="let user of get(); index as i">
                                <td scope="col"><input type="checkbox" id="check_user_{{user.public_token}}" name="check_user_{{user.public_token}}"></td>
                                <td class="text-capitalize" scope="col">{{ user.public_configuration.nome }}</td>
                                <td scope="col">{{ user.email }}</td>
                                <td class="text-capitalize" scope="col">{{ user.public_configuration.type }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div [hidden]="current_type != 'storico' || !getStorico().length">
        <div class="row mt-5">
            <div class="col">
                <div class="table-responsive-md">
                    <table class="table">
                        <thead class="thead-primary">
                            <tr>
                                <th scope="col">Data</th>
                                <th scope="col">Ora</th>
                                <th scope="col">Nome</th>
                                <th scope="col">Partecipanti</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr (click)="handleModal(comunicazione.public_token, 'update')" class="cursor-pointer" *ngFor="let comunicazione of getStorico(); index as i">
                                <td scope="col">{{ getFormatDate(comunicazione.start_timestamp) }}</td>
                                <td scope="col">{{ getFormatTime(comunicazione.start_timestamp) }}</td>
                                <td class="text-capitalize" scope="col">{{ comunicazione.configuration?.title }}</td>
                                <td scope="col">{{ comunicazione.configuration?.targets?.length }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>

</div>

<span id="comunicazioneModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" style="overflow-y: scroll;" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Comunicazione</h4>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(undefined, undefined)">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">

                    <form>
                        <div class="form-row">
                            <div class="col-12">
                                <div class="form-group">
                                    <input [disabled]="!is_editable.value" type="text" class="form-control col-12" id="title_storico" name="title_storico" [(ngModel)]="getComunicazione().configuration.title" placeholder="Titolo">
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12">
                                <textarea class="form-control" [disabled]="!is_editable.value" name="messaggio_storico" id="messaggio_storico" cols="30" rows="5" [(ngModel)]="getComunicazione().configuration.messaggio"></textarea>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12 mb-3">
                                <h5 [hidden]="!!is_editable.value">Partecipanti</h5>

                                <div [hidden]="!is_editable.value" class="dropdown">
                                    <h5 class="fit-content dropdown-toggle" role="button" id="partecipantiDropdown" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Partecipanti
                                    </h5>

                                    <div class="dropdown-menu" aria-labelledby="partecipantiDropdown">
                                        <button class="btn dropdown-item" *ngFor="let user of window.usher.getChildren(); index as i" (click)="addPartecipante(user.public_token)">{{ user.public_configuration.nome }}</button>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-start flex-wrap">
                                    <span *ngFor="let user of getComunicazione().configuration.targets; index as i" class="form-control fit-content">
                                        {{ window.usher.getChildren(user).public_configuration.nome }}
                                        <button [hidden]="!is_editable.value" class="btn btn-sm ml-2" (click)="getComunicazione().configuration.targets.splice(i, 1)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>

                        <div class="form-row" [hidden]="!getComunicazione().configuration.allegati.length && !is_editable.value">
                            <div class="col-12 mb-3">
                                <h5>Allegati
                                    <label [hidden]="!is_editable.value" for="input_allegati" class="btn btn-sm ml-2">
                                        <i class="fa fa-plus"></i>
                                    </label>
                                    <input type="file" hidden multiple id="input_allegati" name="input_allegati" (change)="getDocuments($event, getComunicazione().configuration.allegati)">
                                </h5>
                            </div>
                            <div class="col-12">
                                <div class="d-flex justify-content-start flex-wrap">
                                    <span *ngFor="let allegato of getComunicazione().configuration.allegati; index as i" class="form-control fit-content">
                                        <a target="_blank" [href]="getLink(allegato.name)">{{ allegato.filename }}</a>
                                        <button [hidden]="!is_editable.value" class="btn btn-sm ml-2" (click)="getComunicazione().configuration.allegati.splice(i, 1)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div class="form-row" [hidden]="!getComunicazione().configuration.allegati.length && !is_editable.value">
                            <div class="col-12">
                                <hr>
                            </div>
                        </div>

                        <div class="form-row">
                            <div class="col-md-6 col-sm-12">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <input type="checkbox" id="send_notifica" name="send_notifica" [(ngModel)]="temp_storico.push">
                                        </div>
                                    </div>
                                    <label for="send_notifica" class="form-control">Invia anche tramite notifica</label>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <input type="checkbox" id="send_mail" name="send_mail" [(ngModel)]="temp_storico.email">
                                        </div>
                                    </div>
                                    <label for="send_mail" class="form-control">Invia anche tramite email</label>
                                </div>
                            </div>
                        </div>
                    </form>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary float-left" (click)="is_editable.value = !is_editable.value" [hidden]="!!is_editable.value">Duplica</button>
                    <button type="button" class="btn btn-primary" (click)="send(getComunicazione())" [hidden]="!is_editable.value">Invia</button>
                    <button type="button" class="btn btn-danger" (click)="handleModal(getComunicazione().public_token, 'delete')" [hidden]="!!is_editable.value">Elimina</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(undefined, undefined)">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>

<span id="deleteComunicazioneModal">
    <div class="modal-backdrop fade show" style="display: none;"></div>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Conferma</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="handleModal(getComunicazione().public_token, 'update')">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-row mb-4">
                        <div class="col-12">
                            <p>Cancellando la comunicazione gli utenti a cui è stata inviata non la vedranno più nella dashboard dell'app.</p>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" (click)="deleteComunicazione()" [hidden]="queryparams()['type'] != 'delete'">Elimina</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="handleModal(getComunicazione().public_token, 'update')">Chiudi</button>
                </div>
            </div>
        </div>
    </div>
</span>